import React from "react";
import { DialogActions, makeStyles } from "@material-ui/core";
import { footerButton } from "../../core/styles/ui.constants";

const useStyles = makeStyles((theme) => ({
    dialogFooter: { paddingRight: theme.spacing(4) },
    footerButtons: footerButton(theme),
}));

const DialogFooter = ({ children }) => {
    const classes = useStyles();
    return (
        <DialogActions className={classes.dialogFooter}>
            <div className={classes.footerButtons}>
                {children}
            </div>
        </DialogActions>
    );
};

export default DialogFooter;
